<script setup lang="ts">
import { ref } from 'vue';
import { SphAccordion, SphAccordionItem } from '@/components/base/accordion';
import { useI18n } from '@/composables/i18n';
import SectionClubRelationForm from './SectionClubRelationForm.vue';
import SectionFederationEmployeeRelationForm from './SectionFederationEmployeeRelationForm.vue';
import SectionKindergartenRelationForm from './SectionKindergartenRelationForm.vue';
import SectionPage from './SectionPage.vue';

defineOptions({
    compatConfig: { MODE: 3 },
});

defineProps<{
    federationId: number
}>();

const { i18n } = useI18n();

const openAccordionItem = ref('bereiche');
</script>

<template>
    <div>
        <SphAccordion v-model:model-value="openAccordionItem">
            <SphAccordionItem
                value="bereiche"
                :label="i18n.t('Bereiche')"
            >
                <SectionPage :federation-id="federationId" />
            </SphAccordionItem>
            <SphAccordionItem
                value="einrichtung"
                :label="i18n.t('Einrichtung')"
            >
                <SectionKindergartenRelationForm :federation-id="federationId" />
            </SphAccordionItem>
            <SphAccordionItem
                value="verein"
                :label="i18n.t('Verein')"
            >
                <SectionClubRelationForm :federation-id="federationId" />
            </SphAccordionItem>
            <SphAccordionItem
                value="traegermitarbeiter"
                :label="i18n.t('Trägermitarbeiter')"
            >
                <SectionFederationEmployeeRelationForm :federation-id="federationId" />
            </SphAccordionItem>
        </SphAccordion>
    </div>
</template>
